const globalText = {
    // CTAs
    getADemo: 'Get a Demo',
    watchADemo: 'Watch a Demo',
    learnMore: 'Learn More'
}

export default globalText;